import {
  Box, DashboardModule, Link, Tag, Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useOrderItem from '@hooks/useOrderItem'

import { buildItemTitle } from '@functions/orderItem'

import type { OrderItemModel } from '@models/types'

import ImageGrid from '../ImageGrid'

const OrderItem = (props: {orderItem: OrderItemModel, viewMode: 'small' | 'large'}) => {
  const { orderItem: initOrderItem, viewMode } = props

  const orderItemPayload = useOrderItem(initOrderItem)
  const {
    callbacks: { bulkSelectImages },
    loading,
    orderItem,
  } = orderItemPayload

  const tags = digObject(orderItem, 'data.tags', [])
  const hasTags = !!tags.length

  const specifiedImageIds = digObject(orderItem, 'data.specified_image_ids', [])
  const hasSpecifiedImages = !!specifiedImageIds.length

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      headerRight={(
        <Link
          // @ts-expect-error TS2554
          onClick={() => bulkSelectImages('Order Item')}
          textProps={{
            fontSize: 'small',
            textAlign: 'right',
          }}
        >
          {hasSpecifiedImages ? 'Manage Images' : 'Select Images'}
        </Link>
      )}
      loading={loading}
      title={(
        <>
          {buildItemTitle({ orderableItem: orderItem }) || ''}
          {hasSpecifiedImages && (
            <>
              {' '}
              <Text as="span" color="grey" fontSize="small">
                ({specifiedImageIds.length} image{specifiedImageIds.length === 1 ? '' : 's'} selected)
              </Text>
            </>
          )}
        </>
      )}
    >
      <Box flexDirection="column">
        {!hasSpecifiedImages && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>No Images Selected</DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              This order item hasn&apos;t had any image preferences specified.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {hasSpecifiedImages && (
          <ImageGrid showIdCode specifiedImageIds={specifiedImageIds} viewMode={viewMode} />
        )}

        {hasTags && (
          <DashboardModule.Footer>
            {tags.map((tag: string[]) => (
              // @ts-expect-error TS2322
              <Tag key={tag}>{tag}</Tag>
            ))}
          </DashboardModule.Footer>
        )}
      </Box>
    </DashboardModule>
  )
}

export default OrderItem
